module.exports = __webpack_public_path__ + "img/27.4e105581.gif";